import { useLocalStorage } from 'hooks';

export default function useNavSettings() {
  const collapsedSideNavKey = 'collapsed-side-nav';

  const [collapsedSideNav, setCollapsedSideNav] = useLocalStorage(collapsedSideNavKey, false);

  return { collapsedSideNav, setCollapsedSideNav };
}
